<template>
  <div class="theme-dark gd-review-bar">
    <div class="gd-review-titlebar">
      <button type="button" class="gd-review-close" @click.prevent="closeClicked">
        <i class="far fa-times"></i>
      </button>
      Review Order
    </div>

    <div class="gd-review-container">
      <Spinner v-if="loading" />
      <div class="gd-review-content" v-if="!loading && !hasOrderItems">
        <h2 class="text-center text-muted">No order items for review</h2>
      </div>
      <div class="gd-review-content" v-if="!loading && activeOrderItem && hasOrderItems">
        <h2 class="text-center">Order Item #{{currentOrderItemIndex+1}}</h2>

        <div class="gd-review-group" v-for="approval in activeOrderItem.approvals" :key="approval.name">
          <div class="gd-review-group-header">
            <FormCheckbox v-model="approval.approved" @change="approvalUpdated(approval)" v-if="!requiresPerItemApproval" /> 
            <i v-if="requiresPerItemApproval" :class="['fas', approval.approved ? 'fa-check' : 'fa-caret-right', approval.approved ? 'status-active' : 'text-muted', 'fa-fw']"></i>
            <h3>{{approval.name}}</h3>
          </div>
          <div
            :class="['gd-review-line-item', requiresPerItemApproval ? 'gd-review-line-per-line-approval' : '']" 
            v-for="(approvalItem, index) in approval.items"
            :key="index"
            @mouseenter="approvalItemMouseEnter(approvalItem)"
            @mouseleave="approvalItemMouseLeave(approvalItem)"
            @click.prevent="approvalItemClicked(approval, approvalItem)">

            <div class="row no-gutters">
              <div class="col-4 gd-review-line-name" v-if="approvalItem.name">
                <FormCheckbox v-model="approvalItem.approved" v-if="requiresPerItemApproval" @change="approvalItemUpdated(approval, approvalItem)" /> 
                <i v-if="!requiresPerItemApproval" :class="['fas', approval.approved ? 'fa-check' : 'fa-caret-right', approval.approved ? 'status-active' : 'text-muted', 'fa-fw', 'mr-1']"></i>
                {{approvalItem.name}}
              </div>
              <div :class="['col-8', 'gd-review-line-value', approvalItem.name ? 'gd-review-line-namevalue' : '']">
                <FormCheckbox v-model="approvalItem.approved" v-if="requiresPerItemApproval && !approvalItem.name" @change="approvalItemUpdated(approval, approvalItem)" /> 
                <i v-if="!requiresPerItemApproval && !approvalItem.name" :class="['fas', approval.approved ? 'fa-check' : 'fa-caret-right', approval.approved ? 'status-active' : 'text-muted', 'fa-fw', 'mr-1']"></i>
                {{approvalItem.value}}
              </div>
            </div>
            <div v-if="approvalItem.detailsList && approvalItem.detailsList.length > 0" class="gd-review-line-detail-line">
              <div class="row no-gutters mt-1" v-for="(detailItem, detailIndex) of approvalItem.detailsList" :key="detailIndex">
                <div class="col-11 offset-1">
                  <i :class="['fas', 'fa-angle-right', 'text-muted', 'fa-fw']"></i>
                  {{detailItem}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="gd-review-buttons" v-if="hasOrderItems">
        <div class="row no-gutters">
          <div class="col-6 pr-1">
            <button v-if="!isLastOrderItem" class="btn btn-primary btn-block btn-xlg" @click.prevent="itemCorrectClicked" :disabled="!isActiveOrderItemApproved"><i class="far fa-check-circle"></i> Item Correct</button>
            <button v-if="isLastOrderItem" class="btn btn-primary btn-block btn-xlg" @click.prevent="orderCorrectClicked" :disabled="!isOrderApproved"><i class="far fa-shopping-cart"></i> Order Correct</button>
          </div>
          <div class="col-6 pl-1">
            <button class="btn btn-default btn-block btn-xlg" @click.prevent="$emit('viewDocumentsClicked')"><i class="far fa-book"></i> Documents</button>
          </div>
        </div>
      </div>
    </div>

    <div class="gd-review-footerbar px-2">
      <div class="row no-gutters gd-review-page-area" v-if="hasOrderItems">
        <div class="col-3">
          <button class="btn btn-block btn-default" @click.prevent="currentOrderItemIndex--" :disabled="currentOrderItemIndex == 0"><i class="far fa-angle-left fa-fw"></i></button>
        </div>
        <div class="col-6 gd-review-page-area-display">
          {{currentOrderItemIndex+1}} / {{reviewOrderItemList.length}}
        </div>
        <div class="col-3">
          <button class="btn btn-block btn-default" @click.prevent="currentOrderItemIndex++" :disabled="currentOrderItemIndex >= reviewOrderItemList.length - 1"><i class="far fa-angle-right fa-fw"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
$editor-review-titlebar-height: 30px;
$editor-review-filterbar-height: 50px;
$editor-review-footer-height: 46px;

.gd-review-bar {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-left: 1px solid #a0a0a0;
  user-select: none;
  padding: 0;
}
.gd-review-titlebar {
  width: 100%;
  height: $editor-review-titlebar-height;
  background-color: #415472;
  color: #e4e4e7;
  line-height: $editor-review-titlebar-height;
  font-weight: bold;
  font-size: 15px;
  text-align: center;
  vertical-align: middle;
}
.gd-review-close {
  cursor: pointer;
  float: right;
  border: 0;
  background-color: transparent;
  padding: 1.25rem 1.5rem 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.5rem;
  color: #000000;
  opacity: 0.33;
}
.gd-review-footerbar {
  position: absolute;
  height: $editor-review-footer-height;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $editor-sidebar-background-color;
}
.gd-review-container {
  position: absolute;
  display: flex;
  top: $editor-review-titlebar-height;
  left: 0;
  right: 0;
  bottom: $editor-review-footer-height;
  overflow: hidden;
  background-color: $editor-sidebar-background-color;
  flex-direction: column;
}
.gd-review-buttons {
  height: 60px;
  padding: 6px;
}
.gd-review-top-options {
  padding: 6px;
}
.gd-review-content {
  padding: 0 10px;
  color: #e0e0e0;
  height: 100%;
  overflow-y: auto;
}
.gd-review-group-header {
  margin: 0 0 4px 0;
}

.gd-review-group-header > h3 {
  display: inline-block;
  margin: 0 0 0 8px;
  color: #b0b0b0;
  font-size: 17px;
  font-weight: normal;
}
.gd-review-group {
  margin: 0 0 24px 0;
  font-size: 1.1em;
}
.gd-review-line-item {
  line-height: 1.1em;
  margin: 0 0 2px 0;
  cursor:pointer;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 16px;
}
.gd-review-line-item.gd-review-line-per-line-approval {
  line-height: 0.8em;
  margin-bottom: 0px;
  padding-top: 4px;
  padding-bottom: 0px;
}
.gd-review-line-item.gd-review-line-per-line-approval .gd-review-line-value {
  padding-top: 2px;
  padding-bottom: 0px;
}
.gd-review-line-item.gd-review-line-per-line-approval .gd-review-line-namevalue {
  font-weight: bold;
  padding-top: 8px;  
}
.gd-review-line-item:hover {
  background-color: #404040;
  border-radius: 6px;
}
.gd-review-line-detail-line {
  font-size: 0.8rem;
}

.gd-review-type-button-group > .btn {
  font-size: 0.70rem;
  background: transparent;
  box-shadow: none;
  color: #e4e4e7;
  border: none;
  border-radius: 0;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.gd-review-type-button-group > .btn.active {
  color: #68ACE8;
  border-bottom: 2px solid #68ACE8;
  background: #2C2C2F;
}

.gd-review-footerbar button {
  height: calc(#{$editor-review-footer-height} - 10px);
  padding-top: 4px;
  padding-bottom: 4px;
}
.gd-review-page-area {
  font-size: 1.25rem;
  padding-top: 5px;
}
.gd-review-page-area-display {
  line-height: calc(#{$editor-review-footer-height} - 10px);
  vertical-align: middle;
  text-align: center;
  color: #d7d7d7;
}
</style>


<script>
import _ from 'lodash'
import { mapState } from "vuex"

import Utils from '@/utils/utils'

import { AccountSettingKeys, OrderEditorCutoutTypes, OrderEditorCutoutTypeLookup } from '@/store/types'
import GlassDesignerTypes from '@glass-designer/types'

export default {
  name: 'EditorReviewSideBar',
  data() {
    return {
      editor: null,
      loading: true,

      reviewOrderItemList: [],
      currentOrderItemIndex: 0,
    }
  },
  computed: {
    ...mapState({
      accountSettings: state => state.account.accountSettings
    }),
    activeOrderItem() {
      return this.reviewOrderItemList[this.currentOrderItemIndex]
    },
    isActiveOrderItemApproved() {
      var activeItem = this.activeOrderItem
      if(!activeItem)
        return false

      return activeItem.approvals.filter(approval => !approval.approved).length == 0
    },
    isOrderApproved() {
      return this.reviewOrderItemList.filter(item => {
        return item.approvals.filter(approval => !approval.approved).length > 0
      }).length == 0
    },
    isLastOrderItem() {
      return (this.currentOrderItemIndex == this.reviewOrderItemList.length-1)
    },
    hasOrderItems() {
      return this.reviewOrderItemList.length > 0
    },
    requiresPerItemApproval() {
      if(!this.accountSettings)
        return false

      return parseInt(this.accountSettings[AccountSettingKeys.orderEditorReviewByItem] || 0) != 0
    }
  },
  watch: {
    currentOrderItemIndex: function() {
      this.focusCurrentOrderItem()
    }
  },
  methods: {
    startReview(editor) {
      this.editor = editor
      this.loading = true

      this.reviewOrderItemList = []
      this.currentOrderItemIndex = 0

      this.editor.updateOrderItemList()
      .then(() => {
        this.loading = false

        let orderObj = this.editor.getOrder()

        let reviewItemList = orderObj.orderItems.filter(orderItem => {
          return orderItem.isEditorGeneratedItem && orderItem.editorData && 
            (orderItem.editorData.editorType == GlassDesignerTypes.EditorOrderItemDataTypes.glassShape || orderItem.editorData.editorType == GlassDesignerTypes.EditorOrderItemDataTypes.assemblyGroup)
        })

        this.reviewOrderItemList = _.compact(reviewItemList.map(orderItem => {
          var reviewEditorObject = null

          if(orderItem.editorData.editorType == GlassDesignerTypes.EditorOrderItemDataTypes.glassShape)
            reviewEditorObject = this.editor.getObjectById(orderItem.editorData.glassShapeId)
          if(orderItem.editorData.editorType == GlassDesignerTypes.EditorOrderItemDataTypes.assemblyGroup)
            reviewEditorObject = this.editor.getObjectById(orderItem.editorData.assemblyGroupId)
          if(!reviewEditorObject)
            return null

          // Don't show in review if cancelled / NCR locked
          if(reviewEditorObject.isCancelled() || reviewEditorObject.isNCRLocked())
            return null

          return {
            id: orderItem.id,
            editorObjectId: reviewEditorObject.id,
            approvals: _.cloneDeep(reviewEditorObject.reviewApprovalList)
          }
        }))

        // Jump to the first order item that is not approved
        var firstItemIndex = this.reviewOrderItemList.findIndex(itemReviewInfo => {
          return itemReviewInfo.approvals.some(approval => !approval.approved)
        })
        if(firstItemIndex != -1)
          this.currentOrderItemIndex = firstItemIndex

        this.focusCurrentOrderItem()
      })
    },
    closeClicked() {
      this.$emit('closeReviewClicked')
    },
    focusCurrentOrderItem() {
      if(!this.reviewOrderItemList[this.currentOrderItemIndex])
        return

      var editorObj = this.getCurrentEditorObject()
      if(editorObj) {
        this.editor.moveCameraToEditorObject(editorObj)
      }
    },
    itemCorrectClicked() {
      if(this.currentOrderItemIndex < this.reviewOrderItemList.length-1)
        this.currentOrderItemIndex++
    },
    orderCorrectClicked() {
      if(this.isOrderApproved)
        this.$emit('orderReviewCompleted')
    },
    approvalUpdated(approval) {
      // Update approval list on the shape
      var editorObj = this.getCurrentEditorObject()
      if(editorObj)
        editorObj.updateReviewApprovals(this.reviewOrderItemList[this.currentOrderItemIndex].approvals)
    },
    approvalItemUpdated(approval, approvalItem) {
      approval.approved = approval.items.filter(item => item.approved).length == approval.items.length

      // Update approval list on the shape
      var editorObj = this.getCurrentEditorObject()
      if(editorObj)
        editorObj.updateReviewApprovals(this.reviewOrderItemList[this.currentOrderItemIndex].approvals)
    },
    approvalItemClicked(approval, approvalItem) {
      if(this.requiresPerItemApproval)
        approvalItem.approved = !approvalItem.approved

      // Update approval list on the shape
      var editorObj = this.getCurrentEditorObject()
      if(editorObj)
        editorObj.updateReviewApprovals(this.reviewOrderItemList[this.currentOrderItemIndex].approvals)
    },
    approvalItemMouseEnter(approvalItem) {
      if(approvalItem.bounds)
        this.$emit('itemHighlighted', approvalItem.bounds)
    },
    approvalItemMouseLeave(approvalItem) {
      this.$emit('itemHighlighted', null)
    },
    getCurrentEditorObject() {
      if(this.reviewOrderItemList.length == 0)
        return null
      return this.editor.getObjectById(this.reviewOrderItemList[this.currentOrderItemIndex].editorObjectId)
    }
  }
}
</script>